module.exports = __webpack_public_path__ + "img/interImg.7e0837b3.png";